import { Default, cssTransition } from '../utils';
import '../../../styles/toast.css';
var getConfig = function (animationName, appendPosition) {
    if (appendPosition === void 0) { appendPosition = false; }
    return ({
        enter: "".concat(Default.CSS_NAMESPACE, "--animate ").concat(Default.CSS_NAMESPACE, "__").concat(animationName, "-enter"),
        exit: "".concat(Default.CSS_NAMESPACE, "--animate ").concat(Default.CSS_NAMESPACE, "__").concat(animationName, "-exit"),
        appendPosition: appendPosition,
    });
};
var Bounce = cssTransition(getConfig('bounce', true));
export { Bounce };
